var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-form__agreements" },
    [
      _vm.header ? _c("h3", [_vm._v(_vm._s(_vm.$t(_vm.header)))]) : _vm._e(),
      _vm._v(" "),
      _c("IcFormRowWrapper", {
        attrs: {
          id: _vm.name,
          name: _vm.name,
          labelWidth: 0,
          controlWidth: 12,
          showSingleError: true,
          rowElement: "IcFormRow",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ validator }) {
              return [
                _vm.text
                  ? _c("div", {
                      staticClass: "mbm",
                      staticStyle: { "padding-left": "25px" },
                      domProps: { innerHTML: _vm._s(_vm.$t(_vm.text)) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_visible === true
                  ? _c(
                      "ic-checkbox",
                      {
                        attrs: {
                          id: _vm.name,
                          val: "1",
                          modal: _vm.modal,
                          modalId: "#agreementsModal",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput($event, validator)
                          },
                        },
                        model: {
                          value: _vm.value,
                          callback: function ($$v) {
                            _vm.value = $$v
                          },
                          expression: "value",
                        },
                      },
                      [
                        _c("span", {
                          staticClass: "small",
                          domProps: { innerHTML: _vm._s(_vm.$t(_vm.label)) },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_visible === false
                  ? _c("div", {
                      staticClass: "pt-4",
                      domProps: { innerHTML: _vm._s(_vm.$t(_vm.label)) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.modal
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "h5",
                          attrs: {
                            href: "#",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#agreementsModal",
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("ic_wiecej_info_rodo")),
                            },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.modal
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  id: "agreementsModal",
                  "data-bs-backdrop": "static",
                  "data-bs-keyboard": "false",
                  tabindex: "-1",
                  "aria-labelledby": "agreementsModalLabel",
                  "aria-hidden": "true",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable",
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _c("h1", { staticClass: "h5" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("modal_agreement_header_label")) +
                              " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "btn-close",
                          attrs: {
                            type: "button",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modal-body" },
                        [
                          _vm._t("default"),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t(_vm.content)),
                            },
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: {
                              type: "button",
                              "data-bs-dismiss": "modal",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("zamknij")))]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }